module.exports = __webpack_public_path__ + "static/vwtext-bold-4c0ef71347630cddbe5a24a5253dae5f.woff2";